/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as ChatIndexRouteImport } from './routes/_chat.index'
import { Route as ChatDesignOperationRenderingPrototypeRouteImport } from './routes/_chat.design-operation-rendering-prototype'
import { Route as ChatExperimentsRouteImport } from './routes/_chat.experiments'
import { Route as ChatPullRequestsRouteImport } from './routes/_chat.pull-requests'
import { Route as ChatScheduleRouteImport } from './routes/_chat.schedule'
import { Route as ChatWorkflowsRouteImport } from './routes/_chat.workflows'
import { Route as SettingsAccountRouteImport } from './routes/settings.account'
import { Route as SettingsAdminRouteImport } from './routes/settings.admin'
import { Route as SettingsAppearanceRouteImport } from './routes/settings.appearance'
import { Route as SettingsArchivedRouteImport } from './routes/settings.archived'
import { Route as SettingsConnectionsRouteImport } from './routes/settings.connections'
import { Route as SettingsDiagnosticsRouteImport } from './routes/settings.diagnostics'
import { Route as SettingsFeedbackRouteImport } from './routes/settings.feedback'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsIntegrationsRouteImport } from './routes/settings.integrations'
import { Route as SettingsKeybindingsRouteImport } from './routes/settings.keybindings'
import { Route as SettingsMcpServersRouteImport } from './routes/settings.mcp-servers'
import { Route as SettingsNetworkRouteImport } from './routes/settings.network'
import { Route as SettingsOrganizationsRouteImport } from './routes/settings.organizations'
import { Route as SettingsProjectsRouteImport } from './routes/settings.projects'
import { Route as SettingsProvidersRouteImport } from './routes/settings.providers'
import { Route as SettingsSnapShotRouteImport } from './routes/settings.snap-shot'
import { Route as SettingsSourceControlRouteImport } from './routes/settings.source-control'
import { Route as SettingsUpdatesRouteImport } from './routes/settings.updates'
import { Route as SettingsWorktreesRouteImport } from './routes/settings.worktrees'
import { Route as ChatEnvironmentIdThreadIdRouteImport } from './routes/_chat.$environmentId.$threadId'
import { Route as ChatDraftDraftIdRouteImport } from './routes/_chat.draft.$draftId'

const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const ChatDesignOperationRenderingPrototypeRoute =
  ChatDesignOperationRenderingPrototypeRouteImport.update({
    id: '/design-operation-rendering-prototype',
    path: '/design-operation-rendering-prototype',
    getParentRoute: () => ChatRoute,
  } as any)
const ChatExperimentsRoute = ChatExperimentsRouteImport.update({
  id: '/experiments',
  path: '/experiments',
  getParentRoute: () => ChatRoute,
} as any)
const ChatPullRequestsRoute = ChatPullRequestsRouteImport.update({
  id: '/pull-requests',
  path: '/pull-requests',
  getParentRoute: () => ChatRoute,
} as any)
const ChatScheduleRoute = ChatScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => ChatRoute,
} as any)
const ChatWorkflowsRoute = ChatWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => ChatRoute,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAdminRoute = SettingsAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsArchivedRoute = SettingsArchivedRouteImport.update({
  id: '/archived',
  path: '/archived',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsConnectionsRoute = SettingsConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDiagnosticsRoute = SettingsDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsFeedbackRoute = SettingsFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsKeybindingsRoute = SettingsKeybindingsRouteImport.update({
  id: '/keybindings',
  path: '/keybindings',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsMcpServersRoute = SettingsMcpServersRouteImport.update({
  id: '/mcp-servers',
  path: '/mcp-servers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsNetworkRoute = SettingsNetworkRouteImport.update({
  id: '/network',
  path: '/network',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsOrganizationsRoute = SettingsOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProjectsRoute = SettingsProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProvidersRoute = SettingsProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSnapShotRoute = SettingsSnapShotRouteImport.update({
  id: '/snap-shot',
  path: '/snap-shot',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSourceControlRoute = SettingsSourceControlRouteImport.update({
  id: '/source-control',
  path: '/source-control',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsUpdatesRoute = SettingsUpdatesRouteImport.update({
  id: '/updates',
  path: '/updates',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsWorktreesRoute = SettingsWorktreesRouteImport.update({
  id: '/worktrees',
  path: '/worktrees',
  getParentRoute: () => SettingsRoute,
} as any)
const ChatEnvironmentIdThreadIdRoute =
  ChatEnvironmentIdThreadIdRouteImport.update({
    id: '/$environmentId/$threadId',
    path: '/$environmentId/$threadId',
    getParentRoute: () => ChatRoute,
  } as any)
const ChatDraftDraftIdRoute = ChatDraftDraftIdRouteImport.update({
  id: '/draft/$draftId',
  path: '/draft/$draftId',
  getParentRoute: () => ChatRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof ChatIndexRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/design-operation-rendering-prototype': typeof ChatDesignOperationRenderingPrototypeRoute
  '/experiments': typeof ChatExperimentsRoute
  '/pull-requests': typeof ChatPullRequestsRoute
  '/schedule': typeof ChatScheduleRoute
  '/workflows': typeof ChatWorkflowsRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/admin': typeof SettingsAdminRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/feedback': typeof SettingsFeedbackRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/mcp-servers': typeof SettingsMcpServersRoute
  '/settings/network': typeof SettingsNetworkRoute
  '/settings/organizations': typeof SettingsOrganizationsRoute
  '/settings/projects': typeof SettingsProjectsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/snap-shot': typeof SettingsSnapShotRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/settings/updates': typeof SettingsUpdatesRoute
  '/settings/worktrees': typeof SettingsWorktreesRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
}
export interface FileRoutesByTo {
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/design-operation-rendering-prototype': typeof ChatDesignOperationRenderingPrototypeRoute
  '/experiments': typeof ChatExperimentsRoute
  '/pull-requests': typeof ChatPullRequestsRoute
  '/schedule': typeof ChatScheduleRoute
  '/workflows': typeof ChatWorkflowsRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/admin': typeof SettingsAdminRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/feedback': typeof SettingsFeedbackRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/mcp-servers': typeof SettingsMcpServersRoute
  '/settings/network': typeof SettingsNetworkRoute
  '/settings/organizations': typeof SettingsOrganizationsRoute
  '/settings/projects': typeof SettingsProjectsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/snap-shot': typeof SettingsSnapShotRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/settings/updates': typeof SettingsUpdatesRoute
  '/settings/worktrees': typeof SettingsWorktreesRoute
  '/': typeof ChatIndexRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_chat': typeof ChatRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/_chat/design-operation-rendering-prototype': typeof ChatDesignOperationRenderingPrototypeRoute
  '/_chat/experiments': typeof ChatExperimentsRoute
  '/_chat/pull-requests': typeof ChatPullRequestsRoute
  '/_chat/schedule': typeof ChatScheduleRoute
  '/_chat/workflows': typeof ChatWorkflowsRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/admin': typeof SettingsAdminRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/feedback': typeof SettingsFeedbackRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/mcp-servers': typeof SettingsMcpServersRoute
  '/settings/network': typeof SettingsNetworkRoute
  '/settings/organizations': typeof SettingsOrganizationsRoute
  '/settings/projects': typeof SettingsProjectsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/snap-shot': typeof SettingsSnapShotRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/settings/updates': typeof SettingsUpdatesRoute
  '/settings/worktrees': typeof SettingsWorktreesRoute
  '/_chat/': typeof ChatIndexRoute
  '/_chat/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/_chat/draft/$draftId': typeof ChatDraftDraftIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/usage'
    | '/design-operation-rendering-prototype'
    | '/experiments'
    | '/pull-requests'
    | '/schedule'
    | '/workflows'
    | '/settings/account'
    | '/settings/admin'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/feedback'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/keybindings'
    | '/settings/mcp-servers'
    | '/settings/network'
    | '/settings/organizations'
    | '/settings/projects'
    | '/settings/providers'
    | '/settings/snap-shot'
    | '/settings/source-control'
    | '/settings/updates'
    | '/settings/worktrees'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/settings'
    | '/usage'
    | '/design-operation-rendering-prototype'
    | '/experiments'
    | '/pull-requests'
    | '/schedule'
    | '/workflows'
    | '/settings/account'
    | '/settings/admin'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/feedback'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/keybindings'
    | '/settings/mcp-servers'
    | '/settings/network'
    | '/settings/organizations'
    | '/settings/projects'
    | '/settings/providers'
    | '/settings/snap-shot'
    | '/settings/source-control'
    | '/settings/updates'
    | '/settings/worktrees'
    | '/'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
  id:
    | '__root__'
    | '/_chat'
    | '/settings'
    | '/usage'
    | '/_chat/design-operation-rendering-prototype'
    | '/_chat/experiments'
    | '/_chat/pull-requests'
    | '/_chat/schedule'
    | '/_chat/workflows'
    | '/settings/account'
    | '/settings/admin'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/feedback'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/keybindings'
    | '/settings/mcp-servers'
    | '/settings/network'
    | '/settings/organizations'
    | '/settings/projects'
    | '/settings/providers'
    | '/settings/snap-shot'
    | '/settings/source-control'
    | '/settings/updates'
    | '/settings/worktrees'
    | '/_chat/'
    | '/_chat/$environmentId/$threadId'
    | '/_chat/draft/$draftId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChatRoute: typeof ChatRouteWithChildren
  SettingsRoute: typeof SettingsRouteWithChildren
  UsageRoute: typeof UsageRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/': {
      id: '/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/design-operation-rendering-prototype': {
      id: '/_chat/design-operation-rendering-prototype'
      path: '/design-operation-rendering-prototype'
      fullPath: '/design-operation-rendering-prototype'
      preLoaderRoute: typeof ChatDesignOperationRenderingPrototypeRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/experiments': {
      id: '/_chat/experiments'
      path: '/experiments'
      fullPath: '/experiments'
      preLoaderRoute: typeof ChatExperimentsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/pull-requests': {
      id: '/_chat/pull-requests'
      path: '/pull-requests'
      fullPath: '/pull-requests'
      preLoaderRoute: typeof ChatPullRequestsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/schedule': {
      id: '/_chat/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof ChatScheduleRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/workflows': {
      id: '/_chat/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof ChatWorkflowsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/admin': {
      id: '/settings/admin'
      path: '/admin'
      fullPath: '/settings/admin'
      preLoaderRoute: typeof SettingsAdminRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/archived': {
      id: '/settings/archived'
      path: '/archived'
      fullPath: '/settings/archived'
      preLoaderRoute: typeof SettingsArchivedRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/connections': {
      id: '/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof SettingsConnectionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/diagnostics': {
      id: '/settings/diagnostics'
      path: '/diagnostics'
      fullPath: '/settings/diagnostics'
      preLoaderRoute: typeof SettingsDiagnosticsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/feedback': {
      id: '/settings/feedback'
      path: '/feedback'
      fullPath: '/settings/feedback'
      preLoaderRoute: typeof SettingsFeedbackRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/integrations': {
      id: '/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/keybindings': {
      id: '/settings/keybindings'
      path: '/keybindings'
      fullPath: '/settings/keybindings'
      preLoaderRoute: typeof SettingsKeybindingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/mcp-servers': {
      id: '/settings/mcp-servers'
      path: '/mcp-servers'
      fullPath: '/settings/mcp-servers'
      preLoaderRoute: typeof SettingsMcpServersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/network': {
      id: '/settings/network'
      path: '/network'
      fullPath: '/settings/network'
      preLoaderRoute: typeof SettingsNetworkRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/organizations': {
      id: '/settings/organizations'
      path: '/organizations'
      fullPath: '/settings/organizations'
      preLoaderRoute: typeof SettingsOrganizationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/projects': {
      id: '/settings/projects'
      path: '/projects'
      fullPath: '/settings/projects'
      preLoaderRoute: typeof SettingsProjectsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/providers': {
      id: '/settings/providers'
      path: '/providers'
      fullPath: '/settings/providers'
      preLoaderRoute: typeof SettingsProvidersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/snap-shot': {
      id: '/settings/snap-shot'
      path: '/snap-shot'
      fullPath: '/settings/snap-shot'
      preLoaderRoute: typeof SettingsSnapShotRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/source-control': {
      id: '/settings/source-control'
      path: '/source-control'
      fullPath: '/settings/source-control'
      preLoaderRoute: typeof SettingsSourceControlRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/updates': {
      id: '/settings/updates'
      path: '/updates'
      fullPath: '/settings/updates'
      preLoaderRoute: typeof SettingsUpdatesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/worktrees': {
      id: '/settings/worktrees'
      path: '/worktrees'
      fullPath: '/settings/worktrees'
      preLoaderRoute: typeof SettingsWorktreesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_chat/$environmentId/$threadId': {
      id: '/_chat/$environmentId/$threadId'
      path: '/$environmentId/$threadId'
      fullPath: '/$environmentId/$threadId'
      preLoaderRoute: typeof ChatEnvironmentIdThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/draft/$draftId': {
      id: '/_chat/draft/$draftId'
      path: '/draft/$draftId'
      fullPath: '/draft/$draftId'
      preLoaderRoute: typeof ChatDraftDraftIdRouteImport
      parentRoute: typeof ChatRoute
    }
  }
}

interface ChatRouteChildren {
  ChatDesignOperationRenderingPrototypeRoute: typeof ChatDesignOperationRenderingPrototypeRoute
  ChatExperimentsRoute: typeof ChatExperimentsRoute
  ChatPullRequestsRoute: typeof ChatPullRequestsRoute
  ChatScheduleRoute: typeof ChatScheduleRoute
  ChatWorkflowsRoute: typeof ChatWorkflowsRoute
  ChatIndexRoute: typeof ChatIndexRoute
  ChatEnvironmentIdThreadIdRoute: typeof ChatEnvironmentIdThreadIdRoute
  ChatDraftDraftIdRoute: typeof ChatDraftDraftIdRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatDesignOperationRenderingPrototypeRoute:
    ChatDesignOperationRenderingPrototypeRoute,
  ChatExperimentsRoute: ChatExperimentsRoute,
  ChatPullRequestsRoute: ChatPullRequestsRoute,
  ChatScheduleRoute: ChatScheduleRoute,
  ChatWorkflowsRoute: ChatWorkflowsRoute,
  ChatIndexRoute: ChatIndexRoute,
  ChatEnvironmentIdThreadIdRoute: ChatEnvironmentIdThreadIdRoute,
  ChatDraftDraftIdRoute: ChatDraftDraftIdRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface SettingsRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsAdminRoute: typeof SettingsAdminRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsArchivedRoute: typeof SettingsArchivedRoute
  SettingsConnectionsRoute: typeof SettingsConnectionsRoute
  SettingsDiagnosticsRoute: typeof SettingsDiagnosticsRoute
  SettingsFeedbackRoute: typeof SettingsFeedbackRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute
  SettingsKeybindingsRoute: typeof SettingsKeybindingsRoute
  SettingsMcpServersRoute: typeof SettingsMcpServersRoute
  SettingsNetworkRoute: typeof SettingsNetworkRoute
  SettingsOrganizationsRoute: typeof SettingsOrganizationsRoute
  SettingsProjectsRoute: typeof SettingsProjectsRoute
  SettingsProvidersRoute: typeof SettingsProvidersRoute
  SettingsSnapShotRoute: typeof SettingsSnapShotRoute
  SettingsSourceControlRoute: typeof SettingsSourceControlRoute
  SettingsUpdatesRoute: typeof SettingsUpdatesRoute
  SettingsWorktreesRoute: typeof SettingsWorktreesRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsAdminRoute: SettingsAdminRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsArchivedRoute: SettingsArchivedRoute,
  SettingsConnectionsRoute: SettingsConnectionsRoute,
  SettingsDiagnosticsRoute: SettingsDiagnosticsRoute,
  SettingsFeedbackRoute: SettingsFeedbackRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SettingsKeybindingsRoute: SettingsKeybindingsRoute,
  SettingsMcpServersRoute: SettingsMcpServersRoute,
  SettingsNetworkRoute: SettingsNetworkRoute,
  SettingsOrganizationsRoute: SettingsOrganizationsRoute,
  SettingsProjectsRoute: SettingsProjectsRoute,
  SettingsProvidersRoute: SettingsProvidersRoute,
  SettingsSnapShotRoute: SettingsSnapShotRoute,
  SettingsSourceControlRoute: SettingsSourceControlRoute,
  SettingsUpdatesRoute: SettingsUpdatesRoute,
  SettingsWorktreesRoute: SettingsWorktreesRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ChatRoute: ChatRouteWithChildren,
  SettingsRoute: SettingsRouteWithChildren,
  UsageRoute: UsageRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
